import React from 'react';
import PropTypes from 'prop-types';
import { getActionSectionData } from './configStructure.js';
import moment from 'moment';
import './ActionSection.scss';



const handlePrecision = (amount, precision) => {
    if (amount !== undefined && amount !== null) {
        const arr = `${amount}`.split('.');
        return arr.length > 1
            ? `${arr[0] <= 0 ? arr[0] * -1 : arr[0]}.${arr[1].length === 1 ? `${arr[1]}0` : arr[1].substr(0, precision)}`
            : `${amount <= 0 ? amount * -1 : amount}.00`;
    }
    return '--';
};

const ActionSection = (props) => {
    const REMEDY_CHALLENGE = "REMEDY";
    let formattedFields = props.fields;
    if (props.fields && props.fields.PursueActionParam && props.fields.PursueActionParam[0]) {
        formattedFields = { ...props.fields.PursueActionParam[0], ...props.fields };
    }

    function getConfirmationStatus(eventCode) {
        switch (eventCode) {
            case 'DECISION_WON':
                return 'Accepted';
            case 'DECISION_PARTIAL':
                return 'Partial';
            case 'DECISION_LOST':
                return 'Declined';
            case 'CONFIRMATION_ACCEPTED':
                return 'Acknowledgement Accepted';
            case 'CONFIRMATION_REJECTED':
                return 'Acknowledgement Rejected';
                case 'RULING_WON':
                return 'Won';
                case 'RULING_LOST':
                return 'Lost';
            case 'CONFIRMATION_NOT_EXPECTED':
                return 'Confirmation Unexpected';
            case 'DECISION_NOT_EXPECTED':
                return 'Decision Unexpected';
            case 'CB_API_RES_ACK':
                return getAPIResponseStatus();
            default:
                break;
        }
    }

    const getAckEvent = () => {
        if(props.historyData && props.historyData.length > 0 && props.historyData.filter(event => event.eventCode == 'CB_API_RES_ACK').length > 0)
            return props.historyData.filter(event => event.eventCode == 'CB_API_RES_ACK')[0].eventVerbiage;
    }

    const eventVerbiage = getAckEvent();

    const getAPIResponseStatus = () => {
        if(eventVerbiage !== undefined){
            return eventVerbiage.toLocaleLowerCase().includes('succes') ? 'API Response Accepted' : 'API Response Rejected';
        }
        return "";
    };

    const displayDescription = () => {
        if (eventVerbiage !== undefined) {
            return eventVerbiage.substring(eventVerbiage.indexOf(":") + 1);
        } else if (formattedFields.Description !== null && formattedFields.Description !== undefined) {
            let desc = formattedFields.Description;
            return desc.includes("{") ? desc.substring(0, desc.indexOf(": {")) : desc;
        }
        return "";
    };

    const checkCardBrand = () => {
        if ((props.eventCode == 'CONFIRMATION_ACCEPTED' || props.eventCode == 'CONFIRMATION_REJECTED' || props.configEventCode === 'CB_API_RES_ACK') && 
            (props.cardBrandCode == 'VI' || props.cardBrandCode == 'MC')){
            return true;
        } else 
            return false;
    }

    const actionData = getActionSectionData(props.configEventCode);
    if (props.configEventCode === 'CONFIRMATION_DECISIONS' || props.configEventCode === 'CB_API_RES_ACK') {
        formattedFields.status = getConfirmationStatus(props.eventCode);
    }

    return <div className="action-section-card" >
        <span className="section-title">{props.sectionName}<span className="scope-divider"></span><span className="scope-view">{props.sectionScope}</span></span>
        {actionData !== undefined && formattedFields !== undefined && <span className="section-view" key={actionData.dataColumns?.columnKey}>
            {actionData.dataColumns?.map((list, index) => {
                /* Below check added for new PCF cards fields */
                if (props.configEventCode === 'PURSUE_CASE_FILING' && !formattedFields[list.columnKey]) {
                    return;
                }

                let value, currencyCode;
                switch (list.displayType) {
                    case "CURRENCY":
                        value = handlePrecision(formattedFields[list.columnKey], 2);
                        currencyCode = formattedFields["CurrencyCode"];
                        break;
                    case "STAGE":
                        value = props.stageName;
                        break;
                    case "DATE":
                    value = (props.isMerchantUser) ? moment(props.timeStamp).format(props.dateFormat) : moment(props.timeStamp).format('MM/DD/YYYY')
                        break;
                    case "DATE_ONLY":
                        value = formattedFields[list.columnKey] ? moment(formattedFields[list.columnKey]).format('MM/DD/YYYY') : '--';
                        break;
                    case "NOTE":
                        value = formattedFields[list.columnKeyinternal] ? formattedFields[list.columnKeyinternal] : formattedFields[list.columnKeyExternal];
                        break;
                    case "INDICATOR":
                        value = formattedFields[list.columnKey] ? 'Yes' : 'No';
                        break;

                    default:
                        if(checkCardBrand() && list.name == 'Decision / Status' && props.configEventCode !== 'CB_API_RES_ACK' && eventVerbiage !== undefined){
                            value = formattedFields.Description;
                        }else if((props.cardBrandCode == 'MC' && list.name == 'Decision / Status' && props.configEventCode === 'CB_API_RES_ACK') || (checkCardBrand() && list.name == 'Decision / Status' )){
                            value = formattedFields.status;
                        }else{
                            value = formattedFields[list.columnKey];
                        }
                        break;

                }

                return (!actionData.notesData) ? <span className={props.configEventCode === 'PURSUE_CASE_FILING' ? `list-triple-${Boolean(list.isLastColumn)}` : actionData.isVertical ? "" : "list-vertical-view"} key={index}>
                  <span className={list.isOptional && value === undefined ? "list-view-hidden" : "list-view"} >
                        <span className="list-title">{list.name}</span>
                        {value === undefined ? <span className="list-value">{"--"}</span> : <span className="list-value">{value}{' '}{currencyCode}</span>}
                        </span>
                    {(list.isOptional && value === undefined) ? " " : !list.isLastColumn && actionData.isVertical && <span className="divider">{" "}</span>}
            
                </span> :

                    <div className="list-view-with-footer" key={index}>
                        <span className="list-title-with-footer">{list.name}</span>
                        <span key={index} className="list-value-with-footer">{value === undefined ? "--" : value}{' '}{currencyCode}</span>
                    </div>

            })}
             { props.merchantChallengeType === REMEDY_CHALLENGE && actionData.remedyInfo && actionData.remedyInfo.map((list, index) => {
                return (!actionData.notesData) ? 
                <> {list.isNewRow ? <span className="divider">{" "}</span> : ""}
                   <span className={list.isNewRow ? "list-vertical-view-remedy-new" : "list-vertical-view-remedy"} key={index}>
                    <span className={"list-view"}>
                        <span className="list-title">{list.name}</span>
                        <span className="list-value">{list.value}{' '}</span>
                    </span>
                    { !list.isLastColumn && actionData.isVertical && <span className="divider">{" "}</span>}
                </span> </>:

                    <div className="list-view-with-footer" key={index}>
                        <span className="list-title-with-footer">{list.name}</span>
                        <span key={index} className="list-value-with-footer">{value === undefined ? "--" : value}{' '}{currencyCode}</span>
                    </div>

            })}

            {actionData.reason && <><span className="divider">{" "}</span>
                <div className="section-footer">
                    <span className="section-footer-title">{actionData.reason.name}</span>
                    {actionData.reason.columnKey === 'MemberMessage' ?
                        formattedFields[actionData.reason.columnKey] === undefined ? <span className="section-footer-value">{"--"}</span> : <span className="section-footer-value">{formattedFields[actionData.reason.columnKey]}</span>
                        :
                        formattedFields.Description === undefined ? <span className="section-footer-value">{"--"}</span> :
                        checkCardBrand() ? <span className="section-footer-value">{displayDescription()}</span> : <span className="section-footer-value">{formattedFields.Description}</span>
                    }
                </div></>
            }

            {actionData.notesData &&
                <> {formattedFields.CaseNotes && <span className="divider">{" "}</span>}
                    <div className="section-footer">
                        {formattedFields.CaseNotes && <span className="section-footer-title">{actionData.notesData.name}</span>}
                        {formattedFields.CaseNotes && formattedFields.CaseNotes === undefined ? <span className="section-footer-value">{"--"}</span> : <span className="section-footer-value">{formattedFields.CaseNotes}</span>}
                    </div></>
            }


        </span>}

    </div>


};

ActionSection.propTypes = {
    sectionName: PropTypes.string,
    sectionScope: PropTypes.string,
    eventCode: PropTypes.string,
    fields: PropTypes.object,
    stageName: PropTypes.string,
};

ActionSection.defaultProps = {
};

export default (ActionSection);
